import { all, fork } from 'redux-saga/effects'

import watchStatusSagas from './statusSagas'
import watchElasticIndicesSagas from './elasticIndicesSagas'
import watchElasticAliasesSagas from './elasticAliasesSagas'
import watchElasticTemplatesSagas from './elasticTemplatesSagas'
import watchReindexSagas from './reindexSagas'
import watchSeleneReindexSagas from './seleneReindexSagas'
import watchElasticAggregatesSagas from './elasticAggregatesSagas'
import watchQueueSagas from './queueSagas'
import watchConfigurationSagas from './configurationSagas'
import watchExclusionsSagas from './exclusionsSagas'
import watchAutoVersioningSagas from './autoVersioningSagas'

export default function* rootSaga() {
  yield all([
    fork(watchStatusSagas),
    fork(watchElasticIndicesSagas),
    fork(watchElasticAliasesSagas),
    fork(watchElasticTemplatesSagas),
    fork(watchReindexSagas),
    fork(watchSeleneReindexSagas),
    fork(watchElasticAggregatesSagas),
    fork(watchQueueSagas),
    fork(watchConfigurationSagas),
    fork(watchExclusionsSagas),
    fork(watchAutoVersioningSagas),
  ])
}
